import React from "react";
import { DocumentType } from "@api/graphql/generated/generated-types";
import {
  BaseModalBody,
  BaseModalFooter,
  BaseModalHeader,
} from "@src/common/components/BaseModal";
import CourieButton from "@src/common/components/Button/Button";
import { DOCUMENT_TYPE_LABELS } from "@src/driverDocuments/constants/documentTypeLabels";

export type DriverComplianceWarningContentProps = {
  warningTypes: DocumentType[];
  onClose: () => void;
  onProceed: () => void;
};

export function DriverComplianceWarningContent({
  warningTypes,
  onClose,
  onProceed,
}: DriverComplianceWarningContentProps) {
  return (
    <>
      <BaseModalHeader>Missing Recommended Certifications</BaseModalHeader>
      <BaseModalBody>
        <p className="mb-2">
          The driver is missing the following recommended certifications:
        </p>
        <ul className="list-disc pl-5 mb-4">
          {warningTypes.map((type) => (
            <li key={type}>{DOCUMENT_TYPE_LABELS[type] ?? type}</li>
          ))}
        </ul>
        <p>Do you want to proceed?</p>
      </BaseModalBody>
      <BaseModalFooter className="flex justify-end gap-2">
        <CourieButton color="secondary" onClick={onClose}>
          Cancel
        </CourieButton>
        <CourieButton onClick={onProceed}>Proceed</CourieButton>
      </BaseModalFooter>
    </>
  );
}
